var is_add_click = false;
/*! think-crucial*/ ! function(a, b) {
    var c = function() {
        b(".new-address-header i").click(function() {
            b(this).hasClass("fa-plus-square") ? (b(".account-form.new-address").slideDown(), b(this).removeClass("fa-plus-square"), b(this).addClass("fa-minus-square")) : (b(".account-form.new-address").slideUp(), b(this).removeClass("fa-minus-square"), b(this).addClass("fa-plus-square"))
        }), b(".edit-address-link").click(function(a) {
            a.preventDefault();
            var c = "#" + b(this).data("toggle-form");
            b(this).hasClass("active") ? (b(c).slideUp(), b(this).removeClass("active"), b(this).text("Edit Address")) : (b(c).slideDown(), b(this).addClass("active"), b(this).text("Cancel"))
        })
    };
    a.init = function() {
        c()
    }
}(window.Account = window.Account || {}, jQuery, void 0),
function(a, b) {
    var c = function() {
            b(".total-count, .cart-count, .cart-item-count").html(CartJS.cart.item_count), b(".total-price").html("$" + (CartJS.cart.total_price / 100).toFixed(2) + " USD")
        },
        d = function() {
            b(".thequantity").on("change", function() {
                CartJS.updateItem(1, b(this).val())
            }), b(document).on("cart.requestComplete", function(a, b) {
                c();
            })
        };
    a.init = function() {
        d(), c()
    }
}(window.Cart = window.Cart || {}, jQuery, void 0),
function(a, b) {
    $filterHeader = b(".filter-header"), $relatedHeader = b(".related-header");
    var c = function() {
        $filterHeader.add($relatedHeader).click(function() {
        $height= b("#uncomplicated-categories").height();
            $siblingAccordion = b(this).siblings(".mobile-accordion");

              if(window.innerWidth < 769){

                if($siblingAccordion.hasClass("active")){
                $siblingAccordion.removeClass("active");
                }else{
                $siblingAccordion.addClass("active");
                $siblingAccordion.css("max-height", $height+30);
                }
                if( b(this).hasClass("active")){
                b(this).removeClass("active");
                $siblingAccordion.css("max-height", "0");
                }else{
                b(this).addClass("active");
                }

              }

        }), b(".filter-header a").click(function(a) {
            a.stopPropagation()
        }), b(".filter-row").each(function() {
            if (b(this).hasClass("active")) return $filterHeader.addClass("currently-filtering"), !1
        })
    };
    a.init = function() {
        c()
    }
}(window.Collection = window.Collection || {}, jQuery, void 0),
function(a, b, c) {
    function d() {
        "undefined" !== localStorage.name && null !== localStorage.name && b("#contactFormName").val(localStorage.name), "undefined" !== localStorage.email && null !== localStorage.email && b("#contactFormEmail").val(localStorage.email), "undefined" !== localStorage.phone && null !== localStorage.phone && b("#contactFormTelephone").val(localStorage.phone), "undefined" !== localStorage.message && null !== localStorage.message && b("#contactFormMessage").val(localStorage.message)
    }

    function e() {
        localStorage.name = b("#contactFormName").val(), localStorage.email = b("#contactFormEmail").val(), localStorage.phone = b("#contactFormTelephone").val(), localStorage.message = b("#contactFormMessage").val()
    }

    function f() {
        localStorage.removeItem("name"), localStorage.removeItem("email"), localStorage.removeItem("phone"), localStorage.removeItem("message")
    }
    var g = (b("#contact_form"), function() {
            b(window).on("pagehide", e), d()
        }),
        h = function() {
            b(".successForm").length > 0 && (b(window).scrollTop(0), f()), b("#contact_form").attr("action", "/contact")
        };
    a.init = function() {
        h(), g()
    }
}(window.Contact = window.Contact || {}, jQuery),
function(a, b) {
    var c = function() {
        b(".topic-scroll-link").click(function(a) {
            a.preventDefault();
            var c = b(this).data("scroll-to");
            b(".topic-container").each(function() {
                var a = b(this).data("scroll-to");
                if (a == c) {
                    var d = b(this).offset().top - 155;
                    b("html,body").animate({
                        scrollTop: d
                    }, 400)
                }
            })
        }), b(".scroll-to-top").click(function() {
            b("html,body").animate({
                scrollTop: 0
            }, 400)
        }), b(".topic-title").click(function() {
            if (window.innerWidth < 769) {
                var a = b(this).siblings(".single-topic");
                a.hasClass("active") ? (a.removeClass("active"), b(this).removeClass("active")) : (a.addClass("active"), b(this).addClass("active"))
            }
        })
    };
    a.init = function() {
        c()
    }
}(window.FAQ = window.FAQ || {}, jQuery, void 0),
function(a, b) {
    var c = {
            controls: {
                enable: !1,
                toggleFilterButtons: !0,
                toggleLogic: "and",
                live: !0
            }
        },
        d = {},
        e = {},
        f = function(a, b) {
            var c = [];
            return b.forEach(function(b, d) {
                b.indexOf(a) > -1 && c.push(b.split(a, 2)[1])
            }), c
        },
        g = function(a) {
            return a = a.filter(function(a, b, c) {
                return c.lastIndexOf(a) === b
            }), a.indexOf("") > -1 && a.splice(a.indexOf(""), 1), a
        },
        h = function(a) {
            return a.replace(/[\s\/]/g, "-").replace(/\&/g, "and").toLowerCase()
        },
        i = function(a) {
            return a.replace(/\-/g, " ").replace(/\w\S*/g, function(a) {
                return a.charAt(0).toUpperCase() + a.substr(1).toLowerCase()
            })
        },
        j = function(a, c, d) {
            var e = b('[data-product-id="' + c.id + '"]');
            e.attr("data-index", a).attr("data-price", c.price).attr("data-title", c.title);
            for (var f in d) d[f].forEach(function(a) {
                e.addClass(f + "-" + h(a))
            })
        },
        k = function(a, c, d) {
            if (c.indexOf(null) > -1 && c.splice(c.indexOf(null), 1), c.indexOf("Default Title") > -1 && c.splice(c.indexOf("Default Title"), 1), 0 === c.length) return !1;
            var e = [];
            e.push(b("<div />", {
                class: "filter__title",
                html: i(a)
            })), c.forEach(function(c, d) {
                var f = b("<label />", {
                        class: "filter-option__value",
                        html: i(c),
                        for: h(c)
                    }),
                    g = b("<input />", {
                        type: "checkbox",
                        class: "filter-option__checkbox",
                        value: a,
                        "data-filter": "." + a + "-" + h(c),
                        id: h(c)
                    }),
                    j = b("<div />", {
                        class: "filter-option " + a + "-" + h(c),
                        html: [g, f]
                    });
                e.push(j)
            });
            var f = b("<div />", {
                class: "filter",
                "data-option": a,
                html: e
            });
            b(d).append(f)
        },
        l = function() {
            var a = [],
                c = "";
            for (var d in e) e[d].length > 0 && a.push(e[d]);
            allPossibleCases = function(a) {
                if (0 === a.length) return "";
                if (1 === a.length) return a[0];
                var b = [],
                    c = allPossibleCases(a.slice(1));
                for (var d in c)
                    for (var e = 0; e < a[0].length; e++) b.push(a[0][e] + c[d]);
                return b
            }, 0 === a.length ? c = ".mix" : (c = allPossibleCases(a), c = c.join(",")), b(".mix-container").mixItUp("filter", c)
        },
        m = function(a) {
            var c = b(a).closest("[data-option]").attr("data-option"),
                d = b(a).attr("data-filter");
            b(a).attr("value");
            b(a).prop("checked") === !0 ? (b(a).parent().addClass("filter-option--selected"), e[c].push(d)) : (b(a).parent().removeClass("filter-option--selected"), e[c].splice(e[c].indexOf(d), 1)), l()
        },
        n = function() {
            b(".filter-option").removeClass("filter-option--selected"), b(".filter-option__checkbox:checked").prop("checked", !1);
            for (var a in e) e[a] = [];
            l()
        },
        o = function(a) {
            b(a).hasClass("filter__title--opened") ? (b(a).removeClass("filter__title--opened"), b(a).siblings(".filter-option").slideUp(300)) : (b(a).addClass("filter__title--opened"), b(a).siblings(".filter-option").slideDown(300))
        },
        p = function(a) {
            if (window.collectionItems) {
                window.collectionItems.forEach(function(a, b) {
                    var c = {};
                    for (var e in d) {
                        var g = f(e + ":", a.tags);
                        c[e] = g, d[e] = d[e].concat(g)
                    }
                    j(b, a, c)
                });
                for (var b in d) k(b, g(d[b]), ".collection-filters")
            }
        },
        q = function() {
            b(".mix-container").mixItUp(c)
        },
        r = function() {
            b(document).on("click", ".filter__title", function() {
                o(this)
            }), b(document).on("click", ".collection-filters__clear-all", n), b(document).on("change", ".filter-option__checkbox", function() {
                m(this)
            })
        };
    a.init = function() {
        r(), q(), p()
    }
}(window.Filtering = window.Filtering || {}, jQuery, void 0),
function(a, b) {
    var c = function() {
        b(".footer-nav").click(function() {
            window.innerWidth <= 640 && (b(this).find("ul").slideToggle(200), b(this).hasClass("mobile-active") ? b(this).removeClass("mobile-active") : b(this).addClass("mobile-active"))
        }), b(window).resize(function() {
            window.innerWidth > 640 ? (b(".footer-nav ul").show(), b(".footer-nav").removeClass("mobile-active")) : (b(".footer-nav ul").hide(), b(".footer-nav").removeClass("mobile-active"))
        }), b(".footer-newsletter-form").on("submit", function(a) {
            a.preventDefault();
            var c = b(this);
            b.ajax({
                url: b(this).attr("action"),
                type: b(this).attr("method"),
                data: b(this).serialize(),
                cache: !1,
                dataType: "jsonp",
                jsonp: "c",
                contentType: "application/json; charset=utf-8"
            }).done(function(a) {
                var d = a.msg.replace(/^(0 - )?(.*)/, "$2");
                "error" === a.result ? c.find(".mce_inline_error").length > 0 ? c.find(".mce_inline_error").html(d) : c.find(".mc-field-group").append(b("<div />", {
                    for: "footer-newsletter",
                    class: "mce_inline_error",
                    html: d
                })) : "success" === a.result && c.find(".mce_inline_error").remove().end().find("#mce-success-response").html(d).show()
            })
        })
    };
    a.init = function() {
        c()
    }
}(window.Footer = window.Footer || {}, jQuery, void 0),
function(a, b, c) {
    var d = b(".inline-cart"),
        e = b(".cart-contents-entry-point"),
        f = function() {
            b(".cart-item-count").html(CartJS.cart.item_count);
            if (CartJS.cart.item_count == 0){
                b(".header_checkout_btn").removeClass("header_checkout_btn-active");
              }
              else {
                b(".header_checkout_btn").addClass("header_checkout_btn-active");
              }
        },
        g = function() {
            b.get("/cart?view=contents", function(a) {
                e.html(a)
            })
        },
        h = function(a) {
            var $btn = b(a),
                $form = $btn.closest("form.product-form"),
                c = $btn.attr("data-variant-id"),
                e = $btn.attr("data-variant-qty") || 1;
            if ($form.length) {
                var fid = $form.find('input[name="id"]:checked').val() || $form.find('select[name="id"], input[name="id"][type="hidden"]').val(),
                    fq = $form.find('[name="quantity"]').val();
                fid && (c = fid), fq && (e = fq);
            }
            CartJS.addItem(c, e, {}, {
                success: function(a, b, c) { m() },
                error: function(a, b, c) {
                    var msg = "";
                    try { msg = JSON.parse(a.responseText).description } catch (x) {}
                    var $tile = $btn.hasClass("add-cart") ? $btn.closest(".product-tile") : $();
                    if ($tile.length) {
                        $tile.find(".tc-add-error").remove();
                        var $err = $("<p />", {
                            "class": "tc-add-error",
                            role: "alert",
                            text: "Couldn't add this item. It may have just sold out."
                        }).css({ position: "absolute", left: "5px", right: "5px", bottom: ($tile.innerHeight() - ($btn.offset().top - $tile.offset().top) + 6) + "px", zIndex: 5, margin: 0, padding: "6px 8px", background: "#fff", border: "1px solid #c4501a", borderRadius: "3px", color: "#243844", fontSize: "13px", lineHeight: "1.3", textAlign: "center" });
                        $tile.append($err);
                        setTimeout(function() { $err.remove() }, 5000);
                    } else {
                        window.alert("Sorry, we're unable to do that.\n" + msg)
                    }
                }
            })
        },
        m = function() {
            b.getJSON("/cart.js", function(cart) {
                b(".cart-item-count").html(cart.item_count);
                cart.item_count == 0 ? b(".header_checkout_btn").removeClass("header_checkout_btn-active") : b(".header_checkout_btn").addClass("header_checkout_btn-active")
            }), g(), n();
            if (is_add_click && typeof fbq === "function") { fbq("track", "AddToCart") }
            is_add_click = false
        },
        n = function() {
            window.innerWidth > 769 ? d.addClass("active") : (b(".mobile-menu-wrap, .menu-bars").removeClass("active"), d.addClass("active"), b("html,body").addClass("no-scroll")), k()
        },
        i = function(a) {
            var c = b(a).attr("data-variant-id");
            CartJS.updateItemById(c, 0);
        },
        j = function(a) {
            var c = b(a).attr("data-variant-id");
            CartJS.updateItemById(c, b(a).val())
        },
        k = function() {
            d.hasClass("active") ? (b(".inline-cart-trigger").addClass("transparent"), b("html,body").addClass("no-scroll")) : (b(".inline-cart-trigger").removeClass("transparent"), b("html,body").removeClass("no-scroll"))
        },
        l = function() {
            b(".inline-cart-trigger").click(function(a) {

                a.preventDefault(), n();
              if(is_add_click && typeof fbq === 'function')
              {
                fbq('track', 'AddToCart');
              }


            }), b(".inline-cart").on("click", ".closer", function() {

                window.innerWidth > 769 ? d.removeClass("active") : (d.removeClass("active"), b("html,body").removeClass("no-scroll")), k()
            }), b(".inline-cart").on("click", function() {

                d.hasClass("active") && d.removeClass("active"), k()
            }), b(".inline-cart").on("click", ".inline-cart-container", function(a) {

                a.stopPropagation()
            }), b(".product-details").on("change", ".quantity-select", function() {

                var a = b(this).val();
                b(".add-to-cart").attr("data-variant-qty", a)
            }),

            // Add to Cart - product detail page
            b(".add-to-cart").click(function(a) {
              $(".inline-cart").addClass("deactive");

              $('html').addClass('dis_oveflow');
              $(".inline-cart-trigger").addClass("tada animated antrans");
              is_add_click = true;
//              alert(1)
              a.preventDefault(), window.tcUseBoldAdd === true && window.BOLD && BOLD.helpers && "function" == typeof BOLD.helpers.addItemFromForm && "function" == typeof BOLD.helpers.rivetsUpdate ? BOLD.helpers.addItemFromForm(b(this).closest("form"), function() {
                  BOLD.helpers.rivetsUpdate(function(a) {
                      m()
                  })
              }, function() {
                  var a = arguments[0];
                  console.log(a)
                  window.alert("Sorry, we're unable to do that.\n" + JSON.parse(a.responseText).description)
              }, {
                  endpoint: "/cart/add.js"
              }) : h(this);
//              alert(2)
              //$(".inline-cart").removeClass("active");

              setTimeout(function(){
                $(".inline-cart").removeClass("deactive");
               // $(".inline-cart").removeClass("active");
                //$(".inline-cart-trigger").removeClass('transparent');
                //$("body").removeClass('no-scroll');
                //$("html").removeClass('no-scroll');
              }, 1500)
              setTimeout(function() {
                $(".inline-cart-trigger").removeClass("tada");
              }, 2000)

            }), b(".inline-cart").on("click", ".remove-item", function() {

                 i(this);
            }),

            // Add to Cart - feature product sliders
            b(".add-cart").click(function(a) {
              //$(".inline-cart").addClass("deactive");
              $('html').addClass('dis_oveflow');
              $(".inline-cart-trigger").addClass("tada animated antrans");
              is_add_click = true;
//              alert(3)
              h(this);
              //$(".inline-cart").removeClass("active");
              setTimeout(function(){
                $(".inline-cart").removeClass("deactive");
                //$(".inline-cart").addClass("active");
                //$(".inline-cart-trigger").removeClass('transparent');
                //$("body").removeClass('no-scroll');
                //$("html").removeClass('no-scroll');
              }, 1500)
              setTimeout(function() {
                $(".inline-cart-trigger").removeClass("tada");
              }, 2000)

            }),

            b(".inline-cart").on("change", ".line-item-qtys", function() {
                j(this);
              $(".inline-cart").attr('class', $(".inline-cart").attr('class') + ' active');
            }),

            b(document).on("cart.requestComplete", function(a, b) {
//               alert(4)
                f();
                g();
                k();
            })

        };
    a.init = function() {
        l(), g()
    }
}(window.InlineCart = window.InlineCart || {}, jQuery),
function(a, b) {
    b(".megamenu .megamenu-item").each(function() {
        b(this).hasClass("no-list-children") && b(this).closest(".megamenu").addClass("no-flex")
    });
    var c = function() {},
        d = function() {
            b("[data-has-menu]").hover(function() {
                window.innerWidth > 769 && b(this).addClass("is-active")
            }, function() {
                window.innerWidth > 769 && b(this).removeClass("is-active")
            }), b(".menu-item-link").click(function(a) {
               // a.PreventDefault()
            })
        };
    a.init = function() {
        d(), c()
    }
}(window.Menu = window.Menu || {}, jQuery, void 0),
function(a, b) {
    var c = window.innerWidth,
        d = 3;
    $mobileMenu = b(".mobile-menu"), $mobileMenuWrap = b(".mobile-menu-wrap"), $mobileMenuTrigger = b(".mobile-menu-trigger .menu-bars"), $backLink = b(".mobile-menu .go-back"), $menuLink = b(".mobile-menu .menu-item-link");
    var e = function() {
            c = window.innerWidth
        },
        f = function(a) {
            for (var b = "level-" + a, c = 0; c <= d; c++) {
                var e = "level-" + c;
                $mobileMenu.removeClass(e)
            }
            $mobileMenu.addClass(b)
        },
        g = function(a) {
            var c = b(a).data("slide-to"),
                d = b(a).data("next-menu");
            b(".submenu, .megamenu").hide(), b('[data-menu="' + d + '"]').show(), f(c), $mobileMenu.scrollTop(0)
        },
        h = function() {
            $mobileMenuTrigger.click(function() {
                e(), c < 769 && ($mobileMenuWrap.hasClass("active") ? ($mobileMenuWrap.removeClass("active"), b("html,body").removeClass("no-scroll"), b(this).removeClass("active"), setTimeout(function() {
                    f(0)
                }, 310)) : (b("html,body").addClass("no-scroll"), $mobileMenuWrap.addClass("active"), b(".inline-cart").removeClass("active"), b(".inline-cart-trigger").removeClass("transparent"), b(this).addClass("active")))
            }), $menuLink.add($backLink).click(function(a) {
                b(this).hasClass("last-link") || (a.stopPropagation(), a.preventDefault(), g(this))
            }), b(window).resize(function() {
                e(), c >= 769 && $mobileMenuWrap.hasClass("active") && ($mobileMenuWrap.removeClass("active"), $mobileMenuTrigger.removeClass("active"))
            })
        };
    a.init = function() {
        h()
    }
}(window.MobileMenu = window.MobileMenu || {}, jQuery, void 0), $(".plus-icon").click(function() {
        var a = $(this).data("toggle"),
            b = $(this).data("toggle");
        $(".plus-icon[data-toggle*=" + a + "]").toggleClass("plus-transform"), $(".filter-row[data-match*=" + b + "]").toggle()
    }), window.dxThinkCrucial = window.dxThinkCrucial || {}, dxThinkCrucial.cacheSelectors = function() {
        dxThinkCrucial.cache = {
            $recoverPasswordLink: $("#RecoverPassword"),
            $hideRecoverPasswordLink: $("#HideRecoverPasswordLink"),
            $recoverPasswordForm: $("#RecoverPasswordForm"),
            $customerLoginForm: $("#CustomerLoginForm"),
            $passwordResetSuccess: $("#ResetSuccess")
        }
    }, dxThinkCrucial.init = function() {
        //FastClick.attach(document.body),
            dxThinkCrucial.cacheSelectors(), dxThinkCrucial.loginForms()
    }, dxThinkCrucial.getHash = function() {
        return window.location.hash
    }, dxThinkCrucial.loginForms = function() {
        function a() {
            dxThinkCrucial.cache.$recoverPasswordForm.show(), dxThinkCrucial.cache.$customerLoginForm.hide()
        }

        function b() {
            dxThinkCrucial.cache.$recoverPasswordForm.hide(), dxThinkCrucial.cache.$customerLoginForm.show()
        }
        dxThinkCrucial.cache.$recoverPasswordLink.on("click", function(b) {
            b.preventDefault(), a()
        }), dxThinkCrucial.cache.$hideRecoverPasswordLink.on("click", function(a) {
            a.preventDefault(), b()
        }), "#recover" == dxThinkCrucial.getHash() && a()
    }, dxThinkCrucial.resetPasswordSuccess = function() {
        dxThinkCrucial.cache.$passwordResetSuccess.show()
    }, $(dxThinkCrucial.init),
    function(a, b) {
        var c = function() {
            b(".tabs li").on("click", function() {
                var a = b(this).attr("data-tab");
                b(".tabs li").removeClass("current"), b(".tabs li span").removeClass("tab-title-current"), b(".tab-pane").removeClass("current"), b(this).find("span").toggleClass("tab-title-current"), b(this).addClass("current"), b("#" + a).addClass("current")
            })
        };
        a.init = function() {
            c(), b(".tabs li").hasClass("current") && b(".tabs li.current").find("span").addClass("tab-title-current")
        }
    }(window.Product = window.Product || {}, jQuery, void 0),
    function(a, b) {
        var c = {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: !0,
                arrows: !0,
                prevArrow: '<button class="slick-arrow previous"><i class="fa fa-chevron-left"></i></button>',
                nextArrow: '<button class="slick-arrow next"><i class="fa fa-chevron-right"></i></button>',
                infinite: !0,
                autoplay: !0,
                autoplaySpeed: 6e3,
                adaptiveHeight: !0,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        dots: !1
                    }
                }]
            },
            d = {
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: !1,
                arrows: !0,
                prevArrow: '<button class="slick-arrow previous"><i class="fa fa-angle-left"></i></button>',
                nextArrow: '<button class="slick-arrow next"><i class="fa fa-angle-right"></i></button>',
                infinite: !0,
                autoplay: !0,
                autoplaySpeed: 6e3
            },
            e = {
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: !1,
                arrows: !0,
                prevArrow: '<button class="slick-arrow previous"><i class="fa fa-angle-left"></i></button>',
                nextArrow: '<button class="slick-arrow next"><i class="fa fa-angle-right"></i></button>',
                infinite: !0,
                responsive: [{
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        centerPadding: "60px"
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2,
                        centerPadding: "40px",
                        draggable: !0
                    }
                }, {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: "30px",
                        draggable: !0
                    }
                }]
            },
            f = {
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: !1,
                arrows: !0,
                prevArrow: '<button class="slick-arrow previous"><i class="fa fa-chevron-left"></i></button>',
                nextArrow: '<button class="slick-arrow next"><i class="fa fa-chevron-right"></i></button>',
                infinite: !0,
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        centerMode: !0,
                        slidesToShow: 1
                    }
                }]
            },
            g = {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !1, // !0 IF NEEDED FOR ARROWS ON PRODUCT PAGE (MAIN IMAGE)
                dots: !1,
                focusOnSelect: !0,
                asNavFor: ".product-thumbnails"
            },
            h = {
                slidesToShow: 6,
                slidesToScroll: 1,
                dots: !1,
                arrows: !0,
                focusOnSelect: !0,
                centerMode: !1,
                infinite: !0,
                asNavFor: ".product-slider",
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                        arrows: !1
                    }
                }]
            },
            i = {
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: !0,
                prevArrow: '<i class="fa fa-angle-left"></i>',
                nextArrow: '<i class="fa fa-angle-right"></i>',
                responsive: [{
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: !1
                    }
                }]
            },
            j = function() {
                b(".home-slider").slick(c), b(".featured-products-slider").slick(d), b(".splash-products-slider").slick(e), b(".crucial-brand-collections").slick(f), b(".product-slider").slick(g), b(".product-thumbnails").slick(h), b(".related-products").slick(i)
            },
            k = function() {
                b(".product-slider").on("afterChange", function(a, c, d, e) {
                    b(".product-thumbnails .product-slider-slide").removeClass("active-slide"), b('.product-thumbnails .product-slider-slide[data-index="' + d + '"]').addClass("active-slide")
                }), b(".product-thumbnails").on("click", ".product-slider-slide", function() {
                    b(".product-thumbnails .product-slider-slide").removeClass("active-slide"), b(this).addClass("active-slide")
                })
            };
        a.init = function() {
            k(), j()
        }
    }(window.Sliders = window.Sliders || {}, jQuery, void 0),
    function(a, b) {
        "function" == typeof define && define.amd ? define([], b(a)) : "object" == typeof exports ? module.exports = b(a) : a.tabby = b(a)
    }("undefined" != typeof global ? global : this.window || this.global, function(a) {
        "use strict";
        var b, c, d = {},
            e = "querySelector" in document && "addEventListener" in a && "classList" in document.createElement("_") && "onhashchange" in a,
            f = {
                selectorToggle: "[data-tab]",
                selectorToggleGroup: "[data-tabs]",
                selectorContent: "[data-tabs-pane]",
                selectorContentGroup: "[data-tabs-content]",
                toggleActiveClass: "active",
                contentActiveClass: "active",
                initClass: "js-tabby",
                stopVideo: !0,
                callback: function() {}
            },
            g = function(a, b, c) {
                if ("[object Object]" === Object.prototype.toString.call(a))
                    for (var d in a) Object.prototype.hasOwnProperty.call(a, d) && b.call(c, a[d], d, a);
                else
                    for (var e = 0, f = a.length; e < f; e++) b.call(c, a[e], e, a)
            },
            h = function() {
                var a = {},
                    b = !1,
                    c = 0,
                    d = arguments.length;
                "[object Boolean]" === Object.prototype.toString.call(arguments[0]) && (b = arguments[0], c++);
                for (var e = function(c) {
                        for (var d in c) Object.prototype.hasOwnProperty.call(c, d) && (b && "[object Object]" === Object.prototype.toString.call(c[d]) ? a[d] = h(!0, a[d], c[d]) : a[d] = c[d])
                    }; c < d; c++) {
                    var f = arguments[c];
                    e(f)
                }
                return a
            },
            i = function(a, b) {
                var c, d, e = b.charAt(0);
                for ("[" === e && (b = b.substr(1, b.length - 2), c = b.split("="), c.length > 1 && (d = !0, c[1] = c[1].replace(/"/g, "").replace(/'/g, ""))); a && a !== document; a = a.parentNode) {
                    if ("." === e && a.classList.contains(b.substr(1))) return a;
                    if ("#" === e && a.id === b.substr(1)) return a;
                    if ("[" === e && a.hasAttribute(c[0])) {
                        if (!d) return a;
                        if (a.getAttribute(c[0]) === c[1]) return a
                    }
                    if (a.tagName.toLowerCase() === b) return a
                }
                return null
            },
            j = function(a) {
                "#" === a.charAt(0) && (a = a.substr(1));
                for (var b, c = String(a), d = c.length, e = -1, f = "", g = c.charCodeAt(0); ++e < d;) {
                    if (b = c.charCodeAt(e), 0 === b) throw new InvalidCharacterError("Invalid character: the input contains U+0000.");
                    f += b >= 1 && b <= 31 || 127 == b || 0 === e && b >= 48 && b <= 57 || 1 === e && b >= 48 && b <= 57 && 45 === g ? "\\" + b.toString(16) + " " : b >= 128 || 45 === b || 95 === b || b >= 48 && b <= 57 || b >= 65 && b <= 90 || b >= 97 && b <= 122 ? c.charAt(e) : "\\" + c.charAt(e)
                }
                return "#" + f
            },
            k = function(a, b) {
                if (b.stopVideo && !a.classList.contains(b.contentActiveClass)) {
                    var c = a.querySelector("iframe"),
                        d = a.querySelector("video");
                    if (c) {
                        var e = c.src;
                        c.src = e
                    }
                    d && d.pause()
                }
            },
            l = function(b, c) {
//                 if (!b.hasAttribute("data-tab-no-focus")) {
                    if (!b.classList.contains(c.contentActiveClass)) return void(b.hasAttribute("data-tab-focused") && b.removeAttribute("tabindex"));
                    var d = {
                        x: a.pageXOffset,
                        y: a.pageYOffset
                    };
                    b.focus(), document.activeElement.id !== b.id && (b.setAttribute("tabindex", "-1"), b.setAttribute("data-tab-focused", !0), b.focus()), a.scrollTo(d.x, d.y)
//                 }
            },
            m = function(a, b) {
                var c = i(a, b.selectorToggleGroup);
                if (c) {
                    var d, e = c.querySelectorAll(b.selectorToggle);
                    g(e, function(c) {
                        return c.hash === a.hash ? (c.classList.add(b.toggleActiveClass), d = i(c, "li"), void(d && d.classList.add(b.toggleActiveClass))) : (c.classList.remove(b.toggleActiveClass), d = i(c, "li"), void(d && d.classList.remove(b.toggleActiveClass)))
                    })
                }
            },
            n = function(a, b) {
                var c = document.querySelector(j(a));
                if (c) {
                    var d = i(c, b.selectorContentGroup);
                    if (d) {
                        var e = d.querySelectorAll(b.selectorContent);
                        g(e, function(c) {
                            return c.id === a.substring(1) ? (c.classList.add(b.contentActiveClass), void l(c, b)) : (c.classList.remove(b.contentActiveClass), k(c, b), void l(c, b))
                        })
                    }
                }
            };
        d.toggleTab = function(a, c, d) {
            var e = h(b || f, d || {}),
                g = document.querySelectorAll(j(a));
            n(a, e), c && m(c, e), e.callback(g, c)
        };
        var o = function(e) {
                var f = a.location.hash;
                if (c && (c.id = c.getAttribute("data-tab-id"), c = null), f) {
                    var g = document.querySelector(b.selectorToggle + '[href*="' + f + '"]');
                    d.toggleTab(f, g)
                }
            },
            p = function(d) {
                if (0 === d.button && !d.metaKey && !d.ctrlKey) {
                    var e = i(d.target, b.selectorToggle);
                    if (e && e.hash) {
                        if (e.hash === a.location.hash) return void d.preventDefault();
                        c = document.querySelector(e.hash), c && (c.setAttribute("data-tab-id", c.id), c.id = "")
                    }
                }
            },
            q = function(a) {
                if (c = i(a.target, b.selectorContent), c && !c.classList.contains(b.contentActiveClass)) {
                    var d = c.id;
                    c.setAttribute("data-tab-id", d), c.setAttribute("data-tab-no-focus", !0), c.id = "", location.hash = d
                }
            };
        return d.destroy = function() {
            b && (document.documentElement.classList.remove(b.initClass), document.removeEventListener("click", p, !1), document.removeEventListener("focus", q, !0), a.removeEventListener("hashchange", o, !1), b = null, c = null)
        }, d.init = function(c) {
            e && (d.destroy(), b = h(f, c || {}), document.documentElement.classList.add(b.initClass), document.addEventListener("click", p, !1), document.addEventListener("focus", q, !0), a.addEventListener("hashchange", o, !1), o())
        }, d
    });
//# sourceMappingURL=think-crucial.js.liquid.map
$(document).ready(function() {
  setTimeout(function() {
  $(".star-clickable").click(function(){
    console.log('dd');
    $(".tab-link").removeClass('current');
    $(".tab-link[data-tab='Tab-Reviews']").addClass('current');
    $(".tab-link .tab-title").removeClass('tab-title-current');
    $(".tab-link[data-tab='Tab-Reviews'] .tab-title").addClass('tab-title-current');
    $(".tab-pane").removeClass('current');
    $("#Tab-Reviews").addClass('current');
  })
  }, 1500);

    setTimeout(function() {
        $(".recurring_div").click(function() {
            $('.button.add-to-cart.addtocart').html('Subscribe');
            $(".product-buy").addClass('sub');
            $(".product-buy").removeClass('one')
        });
        $(".one_time_div").click(function() {
            $('.button.add-to-cart.addtocart').html('Add To Cart');
            $(".product-buy").addClass('one');
            $(".product-buy").removeClass('sub')
        });
    }, 3000);
    setTimeout(function() {
        var $dropdownClone = $(".product-form .product-variants select").clone();
        $dropdownClone.bind('change', function() {
            $(".product-form .product-variants select").val(this.value);
            $(".product-form .product-variants select").trigger('change');
        })
        $div = $('<div class="variant_custom_m">');
        $div1 = $('<div class="variant_custom_s">');
        $div1.append($dropdownClone);
        $div.append($div1);
        //       $div.append('</div></div>');
        //       $cont = '<div class="variant_custom_m"><div class="variant_custom_s">' + $dropdownClone + '</div></div>';
        $('.product-buy').append($div);
    }, 5000);

  var url_h = location.href;
  if( url_h.indexOf('/collections/vendors?') >= 0 ) {
    console.log('ff');
    $('.collection-banner .collection-image img').attr('src', '//cdn.shopify.com/s/files/1/1031/7671/collections/shutterstock_369881534_grande.jpg?v=1499928273');
  }
  console.log(location.href);

  $(".available-filters ul div").each(function(){

    if( $(this).hasClass('active') ) {
        $(this).addClass('dd');
      $(this).prev().find('.plus-icon').addClass('plus-transform')
    }

  })
  $(".megamenu-item.menu-item.custom_m").each(function(){

    $(this).find('a').addClass('menu-item-link last-link');

  })


  setTimeout(function() {
    if( $('.recurring_div').length > 0 ) { } else {
    $(".product-buy").addClass('without_sub');
      }

    if( $('.shappify_qb_grid').length > 0 ) {
      $(".one_time_radio_lbl").addClass('showww');
    } else {
          $(".one_time_radio_lbl span").html(' One-time purchase');
          console.log('sd')
            $(".one_time_radio_lbl").addClass('showww');
        }
    }, 2000);

  function is_touch_device() {
    return (('ontouchstart' in window)
        || (navigator.MaxTouchPoints > 0)
        || (navigator.msMaxTouchPoints > 0));
  }

  $(document).on("click", ".st-ui-result", function(){
    if(is_touch_device()){
      window.location.href = $(this).attr("href");
    }
  })

});

  $('.accordion_test').accordion({
    "transitionSpeed": 400,
    singleOpen: false
});

$(document).ready(function(){

  $("#searchList_input").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    $(".searchList_ul li").filter(function() {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
  });

  var noProd = $("#cross-sell .tile-grid>div").length;

  if(noProd == 0){
    $(".section-title.cs-tac").css("display","none");
  }




  $(".search-input.st-default-search-input").on('focus blur', function(){
     $(this).parent().toggleClass('is_focused');
  });


});

var $nav = $('.menu-container-box');
var $btn = $('.menu-container-box .more_btn');
var $vlinks = $('.menu-container-box .main-menu');
var $hlinks = $('.hidden-links');
var $setForget = $('.set-forget-link');

var breaks = [];

function updateNav() {

  // The header no longer renders .menu-container-box; without this the empty-set width maths recurses forever.
  if (!$nav.length || !$vlinks.length) { return; }

  var availableSpace = $btn.hasClass('hidden') ? $nav.width() : $nav.width() - $btn.width() - 40;

  // The visible list is overflowing the nav
  if($vlinks.width() > availableSpace) {

    // Record the width of the list
    breaks.push($vlinks.width());

    // Move item to the hidden list
    $vlinks.children().last().prependTo($hlinks);

    // Show the dropdown btn
    if($btn.hasClass('hidden')) {
      $btn.removeClass('hidden');
      $setForget.addClass("hidden");
    }

  // The visible list is not overflowing
  } else {

    // There is space for another item in the nav
    if(availableSpace > breaks[breaks.length-1]) {

      // Move the item to the visible list
      $hlinks.children().first().appendTo($vlinks);
      breaks.pop();
    }

    // Hide the dropdown btn if hidden list is empty
    if(breaks.length < 1) {
      $btn.addClass('hidden');
      $hlinks.addClass('hidden');
      $setForget.removeClass("hidden");
    }
  }

  // Keep counter updated
  $btn.attr("count", breaks.length);

  // Recur if the visible list is still overflowing the nav
  if($vlinks.width() > availableSpace) {
    updateNav();
  }

}

// Window listeners

$(window).resize(function() {
    updateNav();
  if($(window).width()<769){
    $(".main-menu .menu-item>a").removeAttr("href");
    $(".hidden-links .menu-item>a").removeAttr("href")
  }
});

$('.menu-container-box .more_btn, .overflow, .close_button, .close_menu_mobile').on('click', function() {
  $(".overflow, .close_menu_mobile").fadeToggle();
  $("html,body").toggleClass("no-scroll");

  $('#hidden-menu').animate({
      width: "toggle"
    });

});

 updateNav();

$(document).ready(function(){
  updateNav();
  if($(window).width()<769){
    $(".main-menu .menu-item>a").removeAttr("href");
    $(".hidden-links .menu-item>a").removeAttr("href");
    $(".tap_to_open").click();
    $(".product-buy_info").css("border-left","none");

    $(document).on("scroll", function(){
      if($(this).scrollTop() > 100) {
        $(".menu-container-wrap").slideUp();
      }
      else {
        $(".menu-container-wrap").slideDown();
      }
    })
  }
  $(".hidden-links .menu-item .menu-item-link").append("<span class='fa fa-chevron-right'></span>");

  $(".hidden-links .menu-item").on("click",function(){
      $(this).children(".submenu").slideToggle(500);
  });

  $("header.banner .top-banner-mobile .close_top-banner img").on("click",function(){
      $(".top-banner").slideUp(500);
      $("body").animate({
        paddingTop: "170px"
      }, 500 );
    $(".overflow, #hidden-menu").css({
        top: "71px",
        height: "calc(100% - 71px)"
    });
    $(".inline-cart .close-inline-cart").css({
        top: "-5px"
    });

  });

  $(".open_pop-up, .details_header, .pop-up-info_close, .pop-up-info").on("click",function(){
    $(".pop-up-info").fadeToggle();
    $(".pop-up-info_container").fadeToggle();
    $("html,body").toggleClass("no-scroll");
  });


  //WIDGET - SET & FORGET EDITS

if (window.location.href.indexOf("/products/") > -1) {
    $("#no__months").on("change", function(){
    var value = $(this).val();
    $(".bold-ro__frequency-num").val(value);
  });

  $(".radio-buttons-variants").on("click", function(){
  setTimeout(function(){
    runFirstPrice();
    runTxtChange();
  },50)
  });

  $("#quantity").on("change", function(){
    runFirstPrice();
  })
}

  infoOpen();

});

$(window).load(function(){
  if (window.location.href.indexOf("/products/") > -1) {runTxtChange(); runFirstPrice();}
});

$(".main-menu .menu-item, #hidden-menu .hidden-links .menu-item").on("click",function(){
    $(this).toggleClass("is-active");
  });

function runFirstPrice(){
    var $el = $(".bold-ro__initial-discount-price");
    if (!$el.length || typeof $el.html() !== "string" || typeof $(".bold-ro__secondary-discount-price").html() !== "string") { return; }
    var firstPrice = parseFloat($(".bold-ro__initial-discount-price").html().replace("$","")).toFixed(2);
    var futurePrice = parseFloat($(".bold-ro__secondary-discount-price").html().replace("$","")).toFixed(2);
    var quantity = $("#quantity").val();
    var firstPriceQ = (firstPrice*quantity).toFixed(2);
    var futurePriceQ = (futurePrice*quantity).toFixed(2);
    $("#first-price").html("$" + firstPriceQ);
    $("#future-price").html("$" + futurePriceQ);
};

function runTxtChange(){
    $('input[type=radio][name=bold-ro__selector_radio_button]').on("change", function(){
      if($(".bold-ro__recurring-div").hasClass("bold-ro__bold-active")){
        $(".select-ro-edits, .first-and-future-orders, .buy-text, .discount-bottom, .product-buy_info").fadeIn();
        if($(window).width()<769){
        $(".product-buy_info").css("border-left","none");
        }else{
        $(".product-buy_info").css("border-left","1px solid #adadad");
        }
      }
      else {
        $(".select-ro-edits, .first-and-future-orders, .buy-text, .discount-bottom, .product-buy_info").fadeOut();
        $(".product-buy_info").css("border-left","none");
    }
    });

    $('.bold-ro__recurring-lbl').on("click", function(){
      if($(".bold-ro__recurring-div").hasClass("bold-ro__bold-active")){
        $(".select-ro-edits, .first-and-future-orders, .buy-text, .discount-bottom, .product-buy_info").fadeIn();
        if($(window).width()<769){
        $(".product-buy_info").css("border-left","none");
        }else{
        $(".product-buy_info").css("border-left","1px solid #adadad");
        }
      }
      else {
        $(".select-ro-edits, .first-and-future-orders, .buy-text, .discount-bottom, .product-buy_info").fadeOut();
        $(".product-buy_info").css("border-left","none");
        }
    });
};

function infoOpen(){
//  $(".set-forget-info-btn").mouseenter(function(){
//       //setTimeout(function(){
//          $(".set-forget-info-btn-content").slideDown(300);
//       //},200);
//     })
//     $(".set-forget-info-btn, .set-forget-info-btn-content").mouseleave(function(){
//        $(".set-forget-info-btn-content").slideUp(300);
//     })

    $(".set-forget-info-btn").click(function(){
        $(".set-forget-info-btn-content").slideToggle(300);
    });
  $(".set-forget-close").click(function(){
    $(".set-forget-info-btn").click();
  })
}